import { render, staticRenderFns } from "./DealerForm.vue?vue&type=template&id=50219ff7&"
import script from "./DealerForm.vue?vue&type=script&lang=js&"
export * from "./DealerForm.vue?vue&type=script&lang=js&"
import style0 from "./DealerForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DealerForm.vue"
export default component.exports